export const mockPlans = [
  {
    id: 'business-essentiel',
    role: 'business',
    name: 'Essentiel',
    price_monthly: 5000,
    max_listings: 10,
    max_products: 25,
    storage_mb: 2048,
    modules: ['Shop', 'Work', 'Learn', 'Jobs'],
    description: 'Idéal pour les petites entreprises qui démarrent leur présence en ligne.',
    sort_order: 1,
  },
  {
    id: 'business-premium',
    role: 'business',
    name: 'Premium',
    price_monthly: 10000,
    max_listings: 50,
    max_products: 150,
    storage_mb: 10240,
    modules: ['Shop', 'Work', 'Learn', 'Jobs', 'Apartments', 'Cloud', 'AI', 'Forum'],
    description: 'Pour les entreprises établies qui veulent maximiser leur visibilité.',
    sort_order: 2,
  },
  {
    id: 'freelancer-starter',
    role: 'freelancer',
    name: 'Starter',
    price_monthly: 1000,
    max_listings: 3,
    max_products: 10,
    storage_mb: 512,
    modules: ['Work', 'Forum'],
    description: 'Pour lancer votre activité freelance et proposer vos premiers services.',
    sort_order: 1,
  },
  {
    id: 'freelancer-pro',
    role: 'freelancer',
    name: 'Pro',
    price_monthly: 1500,
    max_listings: 10,
    max_products: 30,
    storage_mb: 2048,
    modules: ['Work', 'Learn', 'Forum', 'Cloud'],
    description: 'Plus de services, plus de visibilité et du stockage supplémentaire.',
    sort_order: 2,
  },
  {
    id: 'user-standard',
    role: 'user',
    name: 'Standard',
    price_monthly: 1000,
    max_listings: 3,
    max_products: 5,
    storage_mb: 256,
    modules: ['Forum', 'Cloud', 'Shop'],
    description: 'Pour publier vos annonces et participer à la communauté.',
    sort_order: 1,
  },
  {
    id: 'instructor-essentiel',
    role: 'instructor',
    name: 'Essentiel',
    price_monthly: 2000,
    max_listings: 3,
    max_products: 10,
    storage_mb: 1024,
    modules: ['Learn', 'Forum'],
    description: 'Pour publier vos premières formations et encadrer vos apprenants.',
    sort_order: 1,
  },
  {
    id: 'instructor-pro',
    role: 'instructor',
    name: 'Pro',
    price_monthly: 2500,
    max_listings: 15,
    max_products: 30,
    storage_mb: 5120,
    modules: ['Learn', 'Forum', 'Cloud', 'AI'],
    description: 'Pour les formateurs actifs avec un catalogue complet.',
    sort_order: 2,
  },
];